import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
import { OutletProductDetailsFragment } from './outletProductDetailsFragment.gql';
export var GET_RELATED_OUTLET_ITEMS_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getRelatedOutletItems($filters: ProductAttributeFilterInput!) {\n    products(filter: $filters) {\n      items {\n        ...OutletProductDetailsFragment\n      }\n    }\n  }\n  ", "\n"])), OutletProductDetailsFragment);
export default {
  getRelatedOutletItems: GET_RELATED_OUTLET_ITEMS_QUERY
};